package com.bikompanion.ui.composables

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import dev.chrisbanes.haze.HazeState
import com.bikompanion.ui.preview.GlassPreviewSurface
import com.bikompanion.ui.strings.LocalStrings

private val BannerShape = RoundedCornerShape(16.dp)

/**
 * Says no bike-share network covers the area in view.
 *
 * Without it, a city the app doesn't cover looks the same as one whose stations are still
 * loading or have failed: an empty map.
 */
@Composable
internal fun NoNetworkHereBanner(
    isVisible: Boolean,
    hazeState: HazeState,
    modifier: Modifier = Modifier,
) {
    if (!isVisible) return
    val strings = LocalStrings.current
    GlassPill(
        hazeState = hazeState,
        modifier = modifier.widthIn(max = 320.dp),
        shape = BannerShape,
    ) {
        Column(modifier = Modifier.padding(horizontal = 12.dp, vertical = 8.dp)) {
            Text(
                text = strings.noNetworkHereTitle,
                style = MaterialTheme.typography.labelLarge,
                fontWeight = FontWeight.SemiBold,
            )
            Text(
                text = strings.noNetworkHereHint,
                style = MaterialTheme.typography.labelMedium,
            )
        }
    }
}

@Preview
@Composable
private fun NoNetworkHereBannerPreview() {
    GlassPreviewSurface { hazeState ->
        NoNetworkHereBanner(isVisible = true, hazeState = hazeState, modifier = Modifier.padding(16.dp))
    }
}

@Preview
@Composable
private fun NoNetworkHereBannerHiddenPreview() {
    GlassPreviewSurface { hazeState ->
        NoNetworkHereBanner(isVisible = false, hazeState = hazeState, modifier = Modifier.padding(16.dp))
    }
}
